//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import SquareButton from './square-button.vue';
import {isoDateFormat} from '../time-utils.js';
import {isSubtask} from '../utils.js';
import {
  bulkRescheduleAtEnd,
  removePlannedFor,
} from '../ordered-relation.js'

export default {
  props: [
    'task',
  ],
  components: {
    SquareButton,
  },
  data() {
    const now = moment();
    return {
      menuOpen: false,
      todayIso: now.clone().startOf('day').format(isoDateFormat),
      tomorrowIso: now.clone().startOf('day').add(1, 'day').format(isoDateFormat),
      thisWeekIso: now.clone().startOf('isoWeek').format(isoDateFormat),
      nextWeekIso: now.clone().startOf('isoWeek').add(1, 'week').format(isoDateFormat),
      thisMonth: now.clone().startOf('month').format(isoDateFormat),
    };
  },
  computed: {
    taskDate() {
      if (this.task.plannedFor &&
          this.task.plannedFor.parentClass === 'day') {
        return this.task.plannedFor.parentKey;
      }
      return null;
    },
    thisMonthAlready() {
      if (this.task.plannedFor &&
          this.task.plannedFor.parentClass === 'month' &&
          this.task.plannedFor.parentKey === this.thisMonth) {
        return true;
      } else {
        return false;
      }
    },
    cannotUnschedule() {
      return !this.task.plannedFor
              || (this.task.plannedFor.parentClass === 'list'
                  && this.task.plannedFor.parentKey === 'backlog'
                  // in case we end up with a subtask scheduled to backlog
                  && this.task.subtaskOf
                  && this.task.subtaskOf.parentClass === 'list'
                  && !this.noBacklogByDefault)
    },
    noBacklogByDefault() {
      return this.$settings && this.$settings.backlogByDefault !== true;
    },
  },
  methods: {
    thisDayAlready(day) {
      if (this.task.plannedFor &&
          this.task.plannedFor.parentClass === 'day' &&
          this.task.plannedFor.parentKey === day) {
        return true;
      } else {
        return false;
      }
    },
    thisWeekAlready(week) {
      if (this.task.plannedFor &&
          this.task.plannedFor.parentClass === 'week' &&
          this.task.plannedFor.parentKey === week) {
        return true;
      } else {
        return false;
      }
    },
    scheduleFor(parentClass, parentKey) {
      this.$reactiveCache.freezeUntil(
        bulkRescheduleAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: [this.task],
          newPPtr: {parentClass, parentKey},
        })
      );
    },
    scheduleForList(listID) {
      this.$reactiveCache.freezeUntil(
        bulkRescheduleAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: [this.task],
          newPPtr: {parentClass: 'list', parentKey: listID},
        })
      );
    },
    unplan() {
      removePlannedFor(this.task)
    },
    chooseCustomDate() {
      this.$root.$emit(
        'date-dialog', {item: this.task}
      )
    },
  },
};
